"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function StatsFromJSON(json) {
    return StatsFromJSONTyped(json, false);
}
exports.StatsFromJSON = StatsFromJSON;
function StatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'symbol': !runtime_1.exists(json, 'symbol') ? undefined : json['symbol'],
        'companyName': !runtime_1.exists(json, 'companyName') ? undefined : json['companyName'],
        'marketCap': !runtime_1.exists(json, 'marketCap') ? undefined : json['marketCap'],
        'dividendYield': !runtime_1.exists(json, 'dividendYield') ? undefined : json['dividendYield'],
        'ytdChangePercent': !runtime_1.exists(json, 'ytdChangePercent') ? undefined : json['ytdChangePercent'],
        'month1ChangePercent': !runtime_1.exists(json, 'month1ChangePercent') ? undefined : json['month1ChangePercent'],
        'month3ChangePercent': !runtime_1.exists(json, 'month3ChangePercent') ? undefined : json['month3ChangePercent'],
        'month6ChangePercent': !runtime_1.exists(json, 'month6ChangePercent') ? undefined : json['month6ChangePercent'],
        'avg30Volume': !runtime_1.exists(json, 'avg30Volume') ? undefined : json['avg30Volume'],
        'week52Change': !runtime_1.exists(json, 'week52Change') ? undefined : json['week52Change'],
        'year5ChangePercent': !runtime_1.exists(json, 'year5ChangePercent') ? undefined : json['year5ChangePercent'],
        'day5ChangePercent': !runtime_1.exists(json, 'day5ChangePercent') ? undefined : json['day5ChangePercent'],
        'peRatio': !runtime_1.exists(json, 'peRatio') ? undefined : json['peRatio'],
        'sharesOutstanding': !runtime_1.exists(json, 'sharesOutstanding') ? undefined : json['sharesOutstanding'],
        'beta': !runtime_1.exists(json, 'beta') ? undefined : json['beta'],
        'day30ChangePercent': !runtime_1.exists(json, 'day30ChangePercent') ? undefined : json['day30ChangePercent'],
        'week52High': !runtime_1.exists(json, 'week52High') ? undefined : json['week52High'],
        'nextDividendDate': !runtime_1.exists(json, 'nextDividendDate') ? undefined : (json['nextDividendDate']),
        'exDividendDate': !runtime_1.exists(json, 'exDividendDate') ? undefined : (json['exDividendDate']),
        'nextEarningsDate': !runtime_1.exists(json, 'nextEarningsDate') ? undefined : (json['nextEarningsDate']),
        'day200MovingAvg': !runtime_1.exists(json, 'day200MovingAvg') ? undefined : json['day200MovingAvg'],
        'maxChangePercent': !runtime_1.exists(json, 'maxChangePercent') ? undefined : json['maxChangePercent'],
        'year2ChangePercent': !runtime_1.exists(json, 'year2ChangePercent') ? undefined : json['year2ChangePercent'],
        'day50MovingAvg': !runtime_1.exists(json, 'day50MovingAvg') ? undefined : json['day50MovingAvg'],
        'year1ChangePercent': !runtime_1.exists(json, 'year1ChangePercent') ? undefined : json['year1ChangePercent'],
        'avg10Volume': !runtime_1.exists(json, 'avg10Volume') ? undefined : json['avg10Volume'],
        'week52Low': !runtime_1.exists(json, 'week52Low') ? undefined : json['week52Low'],
        'ttmDividendRate': !runtime_1.exists(json, 'ttmDividendRate') ? undefined : json['ttmDividendRate'],
        'employees': !runtime_1.exists(json, 'employees') ? undefined : json['employees'],
        'ttmEPS': !runtime_1.exists(json, 'ttmEPS') ? undefined : json['ttmEPS'],
        '_float': !runtime_1.exists(json, 'float') ? undefined : json['float'],
    };
}
exports.StatsFromJSONTyped = StatsFromJSONTyped;
function StatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'symbol': value.symbol,
        'companyName': value.companyName,
        'marketCap': value.marketCap,
        'dividendYield': value.dividendYield,
        'ytdChangePercent': value.ytdChangePercent,
        'month1ChangePercent': value.month1ChangePercent,
        'month3ChangePercent': value.month3ChangePercent,
        'month6ChangePercent': value.month6ChangePercent,
        'avg30Volume': value.avg30Volume,
        'week52Change': value.week52Change,
        'year5ChangePercent': value.year5ChangePercent,
        'day5ChangePercent': value.day5ChangePercent,
        'peRatio': value.peRatio,
        'sharesOutstanding': value.sharesOutstanding,
        'beta': value.beta,
        'day30ChangePercent': value.day30ChangePercent,
        'week52High': value.week52High,
        'nextDividendDate': value.nextDividendDate === undefined ? undefined : (value.nextDividendDate),
        'exDividendDate': value.exDividendDate === undefined ? undefined : (value.exDividendDate),
        'nextEarningsDate': value.nextEarningsDate === undefined ? undefined : (value.nextEarningsDate),
        'day200MovingAvg': value.day200MovingAvg,
        'maxChangePercent': value.maxChangePercent,
        'year2ChangePercent': value.year2ChangePercent,
        'day50MovingAvg': value.day50MovingAvg,
        'year1ChangePercent': value.year1ChangePercent,
        'avg10Volume': value.avg10Volume,
        'week52Low': value.week52Low,
        'ttmDividendRate': value.ttmDividendRate,
        'employees': value.employees,
        'ttmEPS': value.ttmEPS,
        'float': value._float,
    };
}
exports.StatsToJSON = StatsToJSON;
